import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import updateOperators from '../../../actions/api/operators/updateOperators';
import useDialogControl from '../../../hooks/useDialogControl';

/**
 * StaffDetail関連のUI操作とデータ操作を管理するカスタムフック。
 *
 * @param {Object} confirmData - ユーザーの現在の情報を含むオブジェクト。
 * @property {boolean} isEditMode - 編集モードの有無を表す真偽値
 * @property {boolean} showCancelAlertDialog - キャンセル確認ダイアログの表示状態
 * @property {boolean} showDeleteAlertDialog - 削除確認ダイアログの表示状態
 * @property {function} toggleDeleteAlert - 削除確認ダイアログの表示状態をトグルする関数
 * @property {function} toggleCancelAlert - キャンセル確認ダイアログの表示状態をトグルする関数
 * @property {function} handleClose - ダイアログを閉じるためのハンドラー関数
 * @property {function} handleEditButtonClick - 編集ボタン押下時のハンドラー関数
 * @property {function} handleCancelButtonClick - キャンセルボタン押下時のハンドラー関数
 * @property {function} handleUpdateButtonClick - 更新ボタン押下時のハンドラー関数
 * @property {function} handleDeleteButtonClick - 削除ボタン押下時のハンドラー関数
 */
const useStaffDetail = confirmData => {
  const dispatch = useDispatch();
  const apiToken = useSelector(state => state.main.apiToken);
  const [originalConfirmData, setOriginalConfirmData] = useState({});
  const {
    isEditMode,
    toggleEditMode,
    showCancelAlertDialog,
    showDeleteAlertDialog,
    toggleDeleteAlert,
    toggleCancelAlert,
  } = useDialogControl();

  useEffect(() => {
    setOriginalConfirmData(confirmData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const operators = [
    {
      id: confirmData.operatorId,
      role: confirmData.role,
      accountStatus: confirmData.accountStatus,
      remoteSupportStatus: confirmData.remoteSupportStatus,
    },
  ];

  const handleClose = () => dispatch({ type: 'CLOSE_UPDATE_STAFF_DIALOG' });

  const handleEditButtonClick = () => {
    toggleEditMode();
  };

  const handleCancelButtonClick = () => {
    if (originalConfirmData) {
      dispatch({
        type: 'RESET_STAFF_CONFIRM_DATA',
        payload: originalConfirmData,
      });
    }
    toggleEditMode();
    toggleCancelAlert();
  };

  const handleUpdateButtonClick = () => {
    dispatch(updateOperators(apiToken, operators));
    handleClose();
  };

  const handleDeleteButtonClick = () => {
    const updatedOperators = operators.map(operator => ({
      ...operator,
      accountStatus: 0,
    }));
    dispatch(updateOperators(apiToken, updatedOperators));
  };

  return {
    isEditMode,
    showCancelAlertDialog,
    showDeleteAlertDialog,
    toggleDeleteAlert,
    toggleCancelAlert,
    handleClose,
    handleEditButtonClick,
    handleCancelButtonClick,
    handleUpdateButtonClick,
    handleDeleteButtonClick,
  };
};

export default useStaffDetail;
